import { render, staticRenderFns } from "./ResourceSquareIcon.vue?vue&type=template&id=4c067f6c&"
import script from "./ResourceSquareIcon.vue?vue&type=script&lang=js&"
export * from "./ResourceSquareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports